import { useCallback, useEffect } from 'react';
import useLocalStorage from './useLocalStorage';
import { TThemes } from '#/types/common';

const useTheme = () => {
  const [defaultStoreTheme, retrieveTheme] = useLocalStorage<TThemes>('theme');

  const storeTheme = useCallback(
    (theme: TThemes) => {
      defaultStoreTheme(theme);
      document.documentElement.className = theme;
    },
    [defaultStoreTheme]
  );

  useEffect(() => {
    const storedTheme = retrieveTheme();

    if (storedTheme) {
      storeTheme(storedTheme);
    } else {
      storeTheme('light');
    }
  }, [retrieveTheme, storeTheme]);

  return { storeTheme, retrieveTheme };
};

export default useTheme;
